$(function () {
  new timeago().render(document.querySelectorAll('.time-ago'))
})
